import BASE from "./de.json";

export const de = {
  ...BASE,
};
